import { useState } from 'react'

import { CardType, GameType } from 'types/deck'
import { NextPrevOptions } from 'components/elements/Overlay/CardDetailsOverlay'

import AsyncEditionDropdown from 'components/cardSearchPanel/searchFormElements/asyncEditionDropdown'
import CardEditionsGridOverlay from '../CardEditionsGridOverlay'
import PhatButton from 'components/formElements/PhatButton'

import styles from './editionOptions.module.scss'

type Props = {
  card: CardType
  onEditionChanged: (card: CardType) => void
  label?: string
  className?: string
  disabled?: boolean
  game?: GameType
  nextPrevControls?: {
    previous: NextPrevOptions
    next: NextPrevOptions
  }
}

const EditionOptions = ({
  card,
  onEditionChanged,
  label,
  className = '',
  disabled = false,
  nextPrevControls,
  game,
}: Props) => {
  const [viewingAllPrintings, setViewingAllPrintings] = useState(false)

  const handleCardSelectedFromOverlay = (updatedCard: CardType, skipGoBackOnClick?: boolean) => {
    if (!skipGoBackOnClick) setViewingAllPrintings(false)

    setTimeout(() => onEditionChanged(updatedCard), 100) // Prevents flashing
  }

  return (
    <>
      <div className={`${styles.container} ${className}`}>
        {label && <label>{label}</label>}

        <AsyncEditionDropdown
          includeIcon
          key={`${card.id}-edition-dropdown`}
          card={card}
          onCardSelected={onEditionChanged}
          containerClassName={styles.dropdownWrapper}
          triggerClassName={styles.dropdown}
          disabled={disabled}
          game={game}
        />

        <PhatButton icon="grid layout" disabled={disabled} onClick={() => setViewingAllPrintings(true)}>
          <span className={styles.mobile}>Printings</span>
          <span className={styles.desktop}>All printings</span>
        </PhatButton>
      </div>

      <CardEditionsGridOverlay
        open={viewingAllPrintings}
        card={card}
        onClose={() => setViewingAllPrintings(false)}
        onCardSelected={handleCardSelectedFromOverlay}
        nextPrevControls={nextPrevControls}
        overrideGame={game}
      />
    </>
  )
}

export default EditionOptions
